import React from 'react';
import bluesky from './bluesky.svg';

const IconBluesky = () => (
  <div>
    <img src={bluesky} alt="bluesky" />
  </div>
);
export default IconBluesky;
